import React from 'react';
import '../styles/Legal.css';

const Terms = () => (
  <div className="legal-page">
    <h1>Conditions d'utilisation</h1>
    <p>
      Bienvenue sur notre site. Veuillez lire attentivement ces conditions d'utilisation avant d'utiliser ce service.
    </p>
    <h2>1. Acceptation des conditions</h2>
    <p>
      En accédant à ce site, vous acceptez d'être lié par ces conditions d'utilisation, toutes les lois et réglementations applicables, et acceptez que vous êtes responsable du respect des lois locales applicables.
    </p>
    <h2>2. Utilisation du site</h2>
    <p>
      Vous acceptez d'utiliser ce site uniquement à des fins légales et conformément à ces conditions.
    </p>
    <h2>3. Modifications</h2>
    <p>
      Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications prendront effet dès leur publication.
    </p>
    <h2>4. Contact</h2>
    <p>
      Pour toute question concernant ces conditions, veuillez nous contacter.
    </p>
  </div>
);

export default Terms;
